import { c as _c } from "react/compiler-runtime";
export default function CommonInfoBox(t0) {
  const $ = _c(6);
  const {
    message,
    widthFull: t1
  } = t0;
  const widthFull = t1 === undefined ? false : t1;
  const t2 = `${!widthFull && "sm:tw-w-auto"} tw-inline-flex tw-w-full tw-items-center tw-rounded-lg tw-border tw-border-solid tw-border-primary-400/30 tw-bg-primary-400/5 tw-px-4 tw-py-3`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className="tw-h-4 tw-w-4 tw-flex-shrink-0 tw-self-center tw-text-primary-300" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== message) {
    t4 = <div className="tw-flex tw-items-center">{t3}<div className="tw-ml-2 tw-self-center"><h3 className="tw-mb-0 tw-text-sm tw-font-medium tw-text-primary-300">{message}</h3></div></div>;
    $[1] = message;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t2 || $[4] !== t4) {
    t5 = <div className={t2}>{t4}</div>;
    $[3] = t2;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}